import styled from "styled-components";
import CardsAnimation from "../../assets/animations/cards.json";
import Lottie from "lottie-react";

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${(props) => props.fullscreen ? "100vh" : "auto"};
  position: ${(props) => props.fullscreen ? "fixed" : "relative"};
  z-index: 999;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  width: 100%;
  background: linear-gradient(180deg, rgba(0, 109, 156, 0.2) 0%, rgba(104, 55, 115, 0.2) 100%);

`;

const CryptidLoading = ({ size, fullscreen, text }) => {
  return (
    <LoaderWrapper fullscreen={fullscreen}>
      <Lottie
        animationData={CardsAnimation}
      />
    </LoaderWrapper>
  );
};

export default CryptidLoading;